export default __webpack_public_path__ + "static/media/bninidja-color.1fe1eed3.svg";